import { makeStyles } from '@material-ui/core/styles';
import { useAssetSpritesheet } from '@timeflies/assets-loader';
import clsx from 'clsx';
import React from 'react';
var useStyles = makeStyles(function () { return ({
    root: function (_a) {
        var size = _a.size;
        return ({
            position: 'relative',
            width: size,
            height: size,
            overflow: 'hidden'
        });
    },
    background: function (_a) {
        var url = _a.url, size = _a.size, frame = _a.frame, rotate = _a.rotate;
        if (!url || !frame) {
            return {};
        }
        var ratioX = size / frame.width;
        var ratioY = size / frame.height;
        var scale = Math.min(ratioX, ratioY);
        var transform = rotate
            ? "scale(" + scale + ") translate(" + -frame.height / 2 + "px, " + frame.width / 2 + "px) rotate(-90deg)"
            : "scale(" + scale + ") translate(-50%, -50%)";
        return {
            position: 'absolute',
            left: '50%',
            top: '50%',
            backgroundImage: "url(" + url + ")",
            backgroundPosition: -frame.x + "px " + -frame.y + "px",
            backgroundRepeat: 'no-repeat',
            width: frame.width,
            height: frame.height,
            transformOrigin: '0 0',
            transform: transform,
            margin: 'auto',
            imageRendering: 'pixelated'
        };
    },
    // workaround for image-rendering issue in Firefox
    backgroundMoz: {
        imageRendering: 'crisp-edges'
    }
}); });
var getStyleProps = function (asset, textureKey, size) {
    var url = asset === null || asset === void 0 ? void 0 : asset.spritesheetUrl;
    var texture = asset === null || asset === void 0 ? void 0 : asset.spritesheet.textures[textureKey];
    var frame = texture === null || texture === void 0 ? void 0 : texture.frame;
    var rotate = !!(texture === null || texture === void 0 ? void 0 : texture.rotate);
    return {
        size: size,
        url: url,
        frame: frame,
        rotate: rotate
    };
};
export var SpriteImage = React.memo(function (_a) {
    var textureKey = _a.textureKey, size = _a.size, fallback = _a.fallback;
    var asset = useAssetSpritesheet('entities');
    var classes = useStyles(getStyleProps(asset, textureKey, size));
    return (React.createElement("div", { className: classes.root }, asset ?
        React.createElement("div", { className: clsx(classes.background, classes.backgroundMoz) })
        : fallback));
});
